export default "__VITE_ASSET__CehWepq5__"